<template>
    <div>
    <!-- ============================================================== -->
        <!-- Topbar header - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <header class="topbar">
            <nav class="navbar top-navbar navbar-expand-md navbar-light">
                <!-- ============================================================== -->
                <!-- Logo -->
                <!-- ============================================================== -->
                <div class="navbar-header">
                    <router-link :to="{ name: 'index' }" class="navbar-brand">
						<!-- Logo text -->
						<strong style="font-size:24px">{{shortName}}</strong>
                        <span id="topbarlongname">{{longName}}</span>
                    </router-link>
                </div>
                <!-- ============================================================== -->
                <!-- End Logo -->
                <!-- ============================================================== -->
                <div class="navbar-collapse">
                   
                    <!-- ============================================================== -->
                    <!-- toggle and nav items -->
                    <!-- ============================================================== -->
                    <ul class="navbar-nav mr-auto">
                        <!-- This is  -->
                        <li class="nav-item" @click="toggleMenu()"> <a class="nav-link nav-toggler hidden-md-up waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a> </li>
                        <li class="nav-item" @click="toggleMenu()"> <a class="nav-link sidebartoggler hidden-sm-down waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a> </li>
                        <li class="nav-item hidden-sm-down"></li>
                    </ul> 
                    <div>
                        <a v-for="entry in languages" :key="entry.title" @click="changeLocale(entry.language)">
                            <flag :iso="entry.flag" v-bind:squared=false /> {{entry.title}}
                        </a>
                    </div>
                    <!-- ============================================================== -->
                    <!-- User profile and search -->
                    <!-- ============================================================== -->
                    <ul class="navbar-nav my-lg-0">
                        <!-- ============================================================== -->
                        <!-- Profile -->
                        <!-- ============================================================== -->
                        <Profile />
                    </ul>
                </div>
            </nav>
        </header>
        <!-- ============================================================== -->
        <!-- End Topbar header -->
        <!-- ============================================================== -->
    </div>
</template>

<script>
import Profile from './Profile'
import LocalStorage from '@/providers/storage/local'
import i18n from '@/plugins/i18n';
import { productInfo } from '@/mixins/productInfo'

const KEY_IS_MENU_COLLAPSED = "isMenuCollapsed";

export default {
    mixins: [productInfo],
    name: "TopBar",
    components: {
        Profile
    },
    methods: {
        toggleMenu() 
        {
            var isMenuCollapsed = LocalStorage.get(KEY_IS_MENU_COLLAPSED) == "true";
            if(!isMenuCollapsed) {
                LocalStorage.set(KEY_IS_MENU_COLLAPSED,true);
            }
            else {
                LocalStorage.set(KEY_IS_MENU_COLLAPSED,false);
            }
        },
        changeLocale(locale){
            i18n.locale = locale; 
        }
    },
    computed: {
        shortName() {
            return this.productShortName()
        },
        longName() {
            return this.productLongName()
        }
    },
    data() {
      return {
        languages: [
          { flag: 'nl', language: 'nl' },
          { flag: 'gb', language: 'en' }
        ]
      };
    },
    created()
    {
        var isMenuCollapsed = LocalStorage.get(KEY_IS_MENU_COLLAPSED) == "true";
        if(!isMenuCollapsed) {
            LocalStorage.set(KEY_IS_MENU_COLLAPSED,false);
        }
    }
}
</script>